import { render } from "./CourseRevitationContent.vue?vue&type=template&id=72974307&scoped=true"
import script from "./CourseRevitationContent.vue?vue&type=script&lang=js"
export * from "./CourseRevitationContent.vue?vue&type=script&lang=js"

import "./CourseRevitationContent.vue?vue&type=style&index=0&id=72974307&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72974307"]])

export default __exports__